import React from "react";

import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FieldContainer from "./FieldContainer";
import Label from "./Label";
import { wrapperClasses } from "./styles";

import type { JSX } from "react";

import type { InputProps } from "./types";

function Checkbox({
  name,
  label,
  sublabel,
  infoText,
  isRequired = false,
  isReadOnly = false,
  defaultValue,
  isCompact,
  className,
  isNoWrap,
}: InputProps): JSX.Element {
  const { register } = useFormContext();
  const { t } = useTranslation("editor-errors");

  const labelClassNames = classNames(
    "relative mb-0 block size-[20px] rounded-lg border border-input after:absolute after:left-[6px] after:top-[2px] after:h-[11px] after:w-[7px] after:rotate-45 after:border-b-[3px] after:border-r-[3px] after:border-white after:content-[''] has-[:checked]:border-primary has-[:checked]:bg-primary has-[:checked]:after:border-white",
    isReadOnly ? "cursor-not-allowed" : "cursor-pointer",
  );

  return (
    <FieldContainer
      className={className}
      isCompact={isCompact}
      isNoWrap={isNoWrap}
    >
      {label ? (
        <Label
          isCompact={isCompact}
          isRequired={isRequired}
          label={label}
          name={name}
          sublabel={sublabel}
        />
      ) : null}
      <div className={wrapperClasses({ isCompact })}>
        <div className="flex items-center gap-[0.78125rem]">
          <label className={labelClassNames} htmlFor={name}>
            <input
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...register(name, {
                required: isRequired && t("requiredField"),
              })}
              className="invisible size-0"
              defaultValue={defaultValue}
              disabled={isReadOnly}
              id={name}
              type="checkbox"
            />
          </label>
          {infoText}
        </div>
      </div>
    </FieldContainer>
  );
}

export default Checkbox;
